<div *ngIf="statuses?.length" class="status-tracking-graph">
  <div *ngFor="let status of statuses" class="status-tracking-item" [ngClass]="status?.acceptanceType | lowercase">
    <ui-svg-icon [name]="sCodeIcons.get(status.statusCode)" class="status-tracking-item__icon"></ui-svg-icon>
    <div class="status-info">
      <div class="tw-flex">
        <span class="status-info__code">
          {{ status?.statusDescription }}
        </span>
        <ui-tooltip-alert
          *ngIf="status?.latestNotification?.reason"
          [tooltipText]="status?.latestNotification?.reason"
          class="status-info__icon tw-mr-0"
        ></ui-tooltip-alert>
        <ui-tooltip-alert
          *ngIf="status.carrierMessage"
          [tooltipText]="status.carrierMessage"
          [iconType]="iconType.Message"
          [iconSize]="iconSize.Small"
          [iconColor]="iconColor.Black"
          class="status-info__icon tw-mr-0"
        ></ui-tooltip-alert>
      </div>
      <span class="status-info__date">
        <span
          *ngIf="status?.acceptanceType === acceptanceType.NotReceived && status?.assignedArrivalTime"
          class="status-info__expected-at"
        >
          {{ ('load.status.expectedAt' | translate) + ': ' }}
        </span>
        <ui-date-with-timezone
          *ngIf="isTimezoneAvailable; else timezoneNotAvailable"
          [localDate]="status?.assignedArrivalTime"
          class="cropped"
        ></ui-date-with-timezone>
        <ng-template #timezoneNotAvailable>
          {{ status?.assignedArrivalTime | locale : dateFormat : browserTimezone }}
        </ng-template>
      </span>
      <span class="status-info__address">{{ status?.address }}</span>
      <span *ngIf="status?.title" class="status-info__title">{{ status?.title }}</span>
    </div>
  </div>
</div>
